module.exports = __webpack_public_path__ + "img/edit-box.7ef0f707.svg";